import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SettingsDropdown from '../SettingsDropdown';
import Help from '../Help';
import based from './PersonalBar.css';

const PersonalBar = ({ className, helpLink }) => (
  <div className={classnames(based.bar, className)}>
    <SettingsDropdown />
    <Help helpLink={helpLink} />
  </div>
);

PersonalBar.propTypes = {
  className: PropTypes.string,
  helpLink: PropTypes.string,
};

export default PersonalBar;
